import { all, takeLatest, call, put } from 'redux-saga/effects';
import Axios, { AxiosResponse } from 'axios';
import {
  unlinkDBYDSuccess,
  unlinkDBYDFailure,
  updateUserPreferencesSuccess,
  updateUserPreferencesFailure,
  updateConfigurationSuccess,
  updateConfigurationFailure,
  invalidatePermalinkSuccess,
  invalidatePermalinkFailure,
  setEmailLinkingSuccess,
  setEmailLinkingFailure
} from './actions';
import { SettingsActionTypes } from './types';
import { unlinkDBYD, setEmailLinking } from 'services/sentinel.service';
import { updateProfile } from 'services/user.service';
import {
  updateOrganisation,
  invalidateOrganisationPermalink
} from 'services/organisation.service';

function* handleUnlinkDBYD(request: any) {
  try {
    const response: AxiosResponse = yield unlinkDBYD(request.payload);
    if (response) {
      yield put(unlinkDBYDSuccess(response.data));
    } else {
      yield put(unlinkDBYDFailure('Unable to unlink from BYDA'));
    }
  } catch (err) {
    const errMsg = Axios.isAxiosError(err)
      ? err.response?.data?.msg
      : undefined;
    yield put(unlinkDBYDFailure(errMsg || 'Unable to unlink from BYDA'));
  }
}

function* handleUpdateUserPreferences(request: any) {
  try {
    const response: AxiosResponse = yield updateProfile(request.payload);
    if (response) {
      yield put(updateUserPreferencesSuccess(response.data));
    } else {
      yield put(
        updateUserPreferencesFailure('Unable to update user preferences')
      );
    }
  } catch (err) {
    const errMsg = Axios.isAxiosError(err)
      ? err.response?.data?.msg
      : undefined;
    yield put(
      updateUserPreferencesFailure(
        errMsg || 'Unable to update user preferences'
      )
    );
  }
}

function* handleUpdateConfiguration(request: any) {
  try {
    const response: AxiosResponse = yield updateOrganisation(
      request.payload.data
    );
    if (response) {
      yield put(updateConfigurationSuccess(response.data));
    } else {
      yield put(
        updateConfigurationFailure(
          'Unable to update prganisation configuration'
        )
      );
    }
  } catch (err) {
    const errMsg = Axios.isAxiosError(err)
      ? err.response?.data?.msg
      : undefined;
    yield put(
      updateConfigurationFailure(
        errMsg || 'Unable to update prganisation configuration'
      )
    );
  }
}

function* handleSetEmailLinking(request: any) {
  try {
    const response: AxiosResponse = yield setEmailLinking(request.payload);
    if (response) {
      yield put(setEmailLinkingSuccess(response.data));
    } else {
      yield put(setEmailLinkingFailure('Unable to set email link'));
    }
  } catch (err) {
    const errMsg = Axios.isAxiosError(err)
      ? err.response?.data?.msg
      : undefined;
    yield put(setEmailLinkingFailure(errMsg || 'Unable to set email link'));
  }
}

function* handleInvalidatePermalink() {
  try {
    const response: AxiosResponse = yield invalidateOrganisationPermalink();
    if (response?.data.success) {
      yield put(invalidatePermalinkSuccess());
    } else {
      yield put(
        invalidatePermalinkFailure(
          'Unable to invalidate permalink, please try again'
        )
      );
    }
  } catch (err) {
    const errMsg = Axios.isAxiosError(err)
      ? err.response?.data?.msg
      : undefined;
    yield put(
      invalidatePermalinkFailure(
        errMsg || 'Unable to invalidate permalink, please try again'
      )
    );
  }
}

function* watchUnlinkDBYD() {
  yield takeLatest(SettingsActionTypes.UNLINK_DBYD_START, handleUnlinkDBYD);
}

function* watchUpdateUserPreferences() {
  yield takeLatest(
    SettingsActionTypes.UPDATE_USER_PREFERENCES_START,
    handleUpdateUserPreferences
  );
}

function* watchUpdateConfiguration() {
  yield takeLatest(
    SettingsActionTypes.UPDATE_CONFIGURATION_START,
    handleUpdateConfiguration
  );
}

function* watchSetEmailLinking() {
  yield takeLatest(
    SettingsActionTypes.SET_EMAIL_LINKING_START,
    handleSetEmailLinking
  );
}

function* watchInvalidatePermalink() {
  yield takeLatest(
    SettingsActionTypes.INVALIDATE_PERMALINK_START,
    handleInvalidatePermalink
  );
}

function* sagas() {
  yield all([
    call(watchUnlinkDBYD),
    call(watchUpdateUserPreferences),
    call(watchUpdateConfiguration),
    call(watchInvalidatePermalink),
    call(watchSetEmailLinking)
  ]);
}

export default sagas;
